import { makeActionCreator } from '../../../utilities'
import { PatientInformationConstants } from './patientInformation.constants'

export const setSelectedOption = makeActionCreator(PatientInformationConstants.SET_SELECTED_OPTION, 'selectedOption')
export const setHidePatientAndBilling = makeActionCreator(
  PatientInformationConstants.SET_HIDE_PATIENT_AND_BILLING,
  'hidePatientAndBilling'
)
export const setSearchImport = makeActionCreator(PatientInformationConstants.SET_SEARCH_IMPORT, 'searchImport')
export const setNewPatient = makeActionCreator(PatientInformationConstants.SET_NEW_PATIENT, 'newPatient')
export const replacePatient = makeActionCreator(PatientInformationConstants.REPLACE_PATIENT)
export const setPatientInformation = makeActionCreator(
  PatientInformationConstants.SET_PATIENT_INFORMATION,
  'patientInformation'
)
export const refreshPatientData = makeActionCreator(PatientInformationConstants.REFRESH_PATIENT_DATA)
export const resetPatientInformationState = makeActionCreator(
  PatientInformationConstants.RESET_PATIENT_INFORMATION_STATE
)
export const setPatientInformationState = makeActionCreator(
  PatientInformationConstants.SET_PATIENT_INFORMATION_STATE,
  'patientInformation'
)
export const enableScroll = makeActionCreator(PatientInformationConstants.ENABLE_PAGE_SCROLL, '__enablePageScroll')
export const setHasPatient = makeActionCreator(PatientInformationConstants.SET_HAS_PATIENT, 'hasPatient')
